export default __webpack_public_path__ + "static/media/UofTML_2021_DistillingPD.04bbd225.pdf";